import profileManagers from '../../lib/data/createContactOptions';
import { useGetManagersInfo } from './useGetManagersInfo';

export const useGetManagerOptions = () => {
  const managersInfo = useGetManagersInfo();
  return profileManagers(managersInfo.data || []);
};
